module.exports = __webpack_public_path__ + "img/8.2fb091c0.jpg";